var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-input-group",
        { staticClass: "autocomplete-input-group" },
        [
          _c("b-form-input", {
            staticClass: "autocomplete-input-group",
            attrs: {
              id: "input-citizenship",
              size: "sm",
              disabled: _vm.isDisabled,
              placeholder:
                _vm.items.length === 0
                  ? "Создайте гражданство"
                  : "Выберите гражданство",
              state: _vm.state,
              autocomplete: "off"
            },
            on: { focus: _vm.onFocusIn, blur: _vm.onFocusOut },
            model: {
              value: _vm.query,
              callback: function($$v) {
                _vm.query = $$v
              },
              expression: "query"
            }
          }),
          _vm._v(" "),
          _c(
            "b-input-group-append",
            [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", disabled: !_vm.query || _vm.isDisabled },
                  on: { click: _vm.onClear }
                },
                [_c("font-awesome-icon", { attrs: { icon: "times-circle" } })],
                1
              ),
              _vm._v(" "),
              _vm.canCreateCatalog()
                ? _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.v-success",
                          modifiers: { hover: true, "v-success": true }
                        }
                      ],
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: _vm.isDisabled,
                        title: "Создать город"
                      },
                      on: { click: _vm.showModalCatalog }
                    },
                    [_c("font-awesome-icon", { attrs: { icon: "plus" } })],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.isFocus
            ? _c(
                "b-list-group",
                { staticClass: "autocomplete-citizenship" },
                [
                  _vm._l(_vm.filteredItems, function(item, index) {
                    return _c(
                      "b-list-group-item",
                      {
                        key: index,
                        attrs: { button: "" },
                        on: {
                          mousedown: function($event) {
                            return _vm.onClick(item)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.getItemListText(item)) +
                            "\n      "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.items.length === 0 && _vm.query
                    ? _c("b-list-group-item", { attrs: { disabled: "" } }, [
                        _c("small", [_vm._v("Ничего не найдено")])
                      ])
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalVisible
        ? _c("citizenship", {
            attrs: { "create-id": 0 },
            on: {
              "modal-closed": function($event) {
                _vm.isModalVisible = false
              },
              refresh: _vm.onCitizenshipCreated
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb943496", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb943496","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/Citizenships/CitizenshipSelect.vue
// module id = null
// module chunks = 